export const NOTIFICATION_API_FEEDBACK_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "mail",
  FEEDBACK_PATH: "/feedback",
};
